/*
 * Copyright (C) 2023 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { StateResource } from '@common/tech-shared';
import { getUserName, UserProfileResource, UserProfileService } from '@alfa-client/user-profile-shared';
import { AfterViewInit, Component, effect, inject, input, ViewChild } from '@angular/core';
import { DropdownMenuComponent } from '@ods/system';

@Component({
  selector: 'alfa-user-profile-dropdown-container',
  templateUrl: './user-profile-dropdown-container.component.html',
  standalone: false,
})
export class UserProfileDropdownContainerComponent implements AfterViewInit {
  private readonly service = inject(UserProfileService);

  @ViewChild('dropdown') dropDownRef: DropdownMenuComponent;

  public readonly userProfile = input.required<StateResource<UserProfileResource>>();

  public userButtonTooltip: string;

  constructor() {
    effect(() => {
      this.userButtonTooltip = this._getUserButtonTooltip();
    });
  }

  ngAfterViewInit() {
    this.service.registerDropdown(this.dropDownRef);
  }

  _getUserButtonTooltip(): string {
    return `Bearbeiter ändern. Aktueller Bearbeiter: ${getUserName(this.userProfile().resource)}`;
  }
}
